import { render, staticRenderFns } from "./WidgetRenderer.vue?vue&type=template&id=4b822773&scoped=true&"
import script from "./WidgetRenderer.vue?vue&type=script&lang=js&"
export * from "./WidgetRenderer.vue?vue&type=script&lang=js&"
function injectStyles (context) {
  
  var style0 = require("./WidgetRenderer.vue?vue&type=style&index=0&id=4b822773&lang=scss&scoped=true&")
if (style0.__inject__) style0.__inject__(context)

}

/* normalize component */
import normalizer from "!../../../dashboard-carousel/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  injectStyles,
  "4b822773",
  null
  ,true
)

export default component.exports